/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { StatesByCountry } from "~/constants";
import {
  GetPaymentInfoResponseData,
  GetWorldPayFieldMappingsResponseData,
  PayoutCountry,
} from "~/features/myAccount/types";

const transformToCountries = (
  paymentInfoResData: GetPaymentInfoResponseData,
  worldPayResData: GetWorldPayFieldMappingsResponseData,
) => {
  const countries: Record<string, PayoutCountry> = {};

  paymentInfoResData.validation.country.options.forEach((countryCode) => {
    countries[countryCode] = {
      countryCode,
    };

    const payData = worldPayResData[countryCode];

    if (payData) {
      countries[countryCode].payment = {
        requiresSWIFT: payData.RequiresSWIFT,
        requiresBankCode: payData.RequiresBankCode,
        requiresBBAN: payData.RequiresBBAN,
        requiresIBAN: payData.RequiresIBAN,
      };
    }

    const validStateCodes = StatesByCountry[countryCode as keyof typeof StatesByCountry];
    if (validStateCodes) {
      const states: Record<string, string> = {};

      Object.keys(paymentInfoResData.validation.state.extras).forEach((stateCode) => {
        if (validStateCodes.includes(stateCode)) {
          states[stateCode] = paymentInfoResData.validation.state.extras[stateCode];
        }
      });

      countries[countryCode].states = states;
    }
  });

  return countries;
};

export default transformToCountries;
